import React from 'react'
import StarRating from 'components/star-rating'

import theme from 'styles/theme'

import {
  ReviewContainer,
  ReviewQuote,
  ReviewQuoteText,
  ReviewQuoteSource,
  ReviewInfo,
  ReviewStars,
  ReviewDate
} from './styled'

interface TestimonialEdge {
  node: Testimonial
}

type Props = {
  testimonialEdge: TestimonialEdge
}

const Review = ({ testimonialEdge  }: Props) => {
	const getTestimonialStarRating = (t: TestimonialEdge) => t.node.score / 20

	// testimonial dates come in as an ISO string
	const getTestimonialDateString = (t: TestimonialEdge) => {
		const testimonialDate = new Date(t.node.date)
		return `${testimonialDate.getMonth() + 1}/${testimonialDate.getDate()}/${testimonialDate.getFullYear()}`
	}

	let authorString = ``
	if (testimonialEdge.node.name && testimonialEdge.node.author_description) {
		authorString = `${testimonialEdge.node.name}, ${testimonialEdge.node.author_description}`
	} else {
		authorString = `${testimonialEdge.node.name || testimonialEdge.node.author_description}`
	}

  return (
  	<ReviewContainer>
  		<ReviewQuote>
	  		<ReviewQuoteText>
		  		{testimonialEdge.node.quote}
	  		</ReviewQuoteText>
	  		<ReviewQuoteSource>
		  		-{authorString}
	  		</ReviewQuoteSource>
  		</ReviewQuote>
  		<ReviewInfo>
  			<ReviewStars>
	      	<StarRating
	      		rating={getTestimonialStarRating(testimonialEdge)}
	      		name="review-rating"
	      		fillColor={theme.color.accent.secondary}
	      		starDimension="2rem"
	      		starSpacing="0.2rem"
	      	/>
  			</ReviewStars>
  			<ReviewDate>
  				{getTestimonialDateString(testimonialEdge)}
  			</ReviewDate>
  		</ReviewInfo>
  	</ReviewContainer>
  )
}

export default Review
